import axios from "axios";
import { useEffect } from "react";
import { useContext, useState } from "react";
import StateContext from "../../../contextAPI/context";
// Importing inputfield
import Flatpickr from "react-flatpickr";
import moment from "moment";
import Tippy from "@tippyjs/react";

// Redux
import { useSelector } from "react-redux";

const wrapperClass =
  "sm:flex-col sm:justify-start sm:items-start sm:w-1/2 space-y-1 sm:my-0.5 flex-auto sm:inline-block p-1 rounded";
// const wrapperClass = "flex";
const removeBtnClass =
  "absolute top-1 right-1 w-6 h-6 hover:text-rose-600 cursor-pointer";
export const NewInputComponent = (props) => {
  const {
    index,
    label,
    id,
    type,
    min,
    max,
    is_required,
    placeholder,
    onChange,
    tooltip,
    onBlur,
    selected,
    validation_api_id,
    validateobj,
    prior_date,
    future_date,
    future_end_date,
    userinfo,
  } = props;
  const {
    performanceid,
    setPerformanceId,
    submitperform,
    setSubmitPerform,
    setActivityParams,
    setFocusControlId,
    checkfocus,
  } = useContext(StateContext);

  const { activitydropdownparams } = useSelector((state) => state.performance);

  const [value, setValue] = useState({ value: "" });
  const [controlvalue, setControlValue] = useState();
  const [a_performance, setA_Performance] = useState([]);
  const [change, setChange] = useState(true);
  var required = is_required;
  if (type === "date") {
    var today = new Date().toISOString().split("T")[0];
  }
  useEffect(() => {
    if (performanceid !== undefined && performanceid.length !== 0) {
      getActivityPerformance(performanceid);
    }
  }, [performanceid]);
  useEffect(() => {
    if (a_performance.length !== 0) {
      a_performance.map((ele) => {
        if (ele.custom_field_id === props.id) {
          setControlValue(ele.value);
        }
      });
    }
  }, [a_performance]);

  useEffect(() => {
    if (submitperform) {
      setValue({ value: "" });
      setControlValue("");
      setTimeout(() => {
        setSubmitPerform(false);
      }, 2000);
    }
  }, [submitperform]);
  const getActivityPerformance = (id) => {
    setChange(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/activityperformance/${id}`)
      .then((res) => {
        setA_Performance(res.data.data[0].todo_custom_controls);
        setPerformanceId("");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateValue = (e) => {
    const { value } = e.target;
    setChange(false);
    setValue({ value: value });
  };

  return (
    <div className={wrapperClass + selected + "border border-blue-500"}>
      <label htmlFor={index} className="text-sm font-medium mb-1">
        {label || type + " field"}
        {is_required === true ? (
          <span className="text-rose-500 ml-1">*</span>
        ) : null}
      </label>
      <div className="top-7 float-right pl-10 mb-1 rtl-grid">
        {tooltip !== "" && (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>
      <br />
      <input
        {...{ type, id, required, placeholder }}
        key={index}
        name={label || type + " field"}
        className={`form-input w-full ${
          props.internaluser ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
        onChange={(e) => {
          onChange(e, id, type, min, max);
          updateValue(e);
        }}
        onBlur={(e) => {
          props.index.map((ele) => {
            activitydropdownparams.map((item) => {
              if (ele.label === item && ele.id === id) {
                setActivityParams(e.target.value);
              }
            });
          });
          if (
            props.validation_api_id?.trim() !== "" &&
            props.validation_api_id !== null &&
            checkfocus
          ) {
            setFocusControlId(props.id);
            onBlur(e, validation_api_id);
          }
        }}
        min={
          type === "number"
            ? min
            : type === "date" && prior_date
            ? min
            : future_end_date
            ? min
            : today
        }
        max={
          type === "number"
            ? max
            : type === "date" && future_date
            ? max
            : future_end_date
            ? userinfo.estimated_time.slice(0, 10)
            : today
        }
        minLength={type === "text" ? min : null}
        maxLength={type === "text" ? max : null}
        value={
          Object.keys(a_performance).length !== 0 && change
            ? controlvalue
            : value.value
        }
        autoComplete="off"
        disabled={props.internaluser}
      />
      {validateobj?.map((item) => {
        return (
          item.id === id && (
            <div className="text-xs text-rose-600 pt-1 pl-1">
              Blank space is not allowed in {label || type + " field"}.
            </div>
          )
        );
      })}
    </div>
  );
};
NewInputComponent.defaultProps = {
  min: 1,
  max: 10,
  required: false,
  placeholder: "",
  tooltip: "",
};

export const NewTextareaComponent = (props) => {
  const {
    id,
    index,
    label,
    type,
    is_required,
    placeholder,
    onChange,
    tooltip,
    preceding_0,
    selected,
    onBlur,
    validation_api_id,
    validateobj,
  } = props;
  const [value, setValue] = useState({ value: "" });
  const [a_performance, setA_Performance] = useState([]);
  const [controlvalue, setControlValue] = useState();
  const [change, setChange] = useState(true);
  const {
    performanceid,
    setPerformanceId,
    submitperform,
    setSubmitPerform,
    setActivityParams,
    setFocusControlId,
    checkfocus,
  } = useContext(StateContext);
  const { activitydropdownparams } = useSelector((state) => state.performance);

  useEffect(() => {
    if (performanceid !== undefined && performanceid.length !== 0) {
      getActivityPerformance(performanceid);
    }
  }, [performanceid]);
  useEffect(() => {
    if (a_performance !== 0) {
      a_performance.map((ele) => {
        if (ele.custom_field_id === props.id) {
          setControlValue(ele.value);
        }
      });
    }
  }, [a_performance]);

  useEffect(() => {
    if (submitperform) {
      setValue({ value: "" });
      setControlValue("");
      setTimeout(() => {
        setSubmitPerform(false);
      }, 2000);
    }
  }, [submitperform]);
  const getActivityPerformance = (id) => {
    setChange(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/activityperformance/${id}`)
      .then((res) => {
        setA_Performance(res.data.data[0].todo_custom_controls);
        setPerformanceId("");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateValue = (e) => {
    const { value } = e.target;
    setChange(false);
    setValue({ value: value });
  };

  return (
    <div className={wrapperClass + selected}>
      <label htmlFor={index} className="text-sm font-medium mb-1">
        {label || "Input field"}
        {is_required === true ? (
          <span className="text-rose-500 ml-1">*</span>
        ) : null}
      </label>
      <div className="top-7 float-right pl-10 mb-1 rtl-grid">
        {tooltip !== "" && (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>
      <br />
      <textarea
        {...{ id, is_required, placeholder }}
        key={index}
        name={label || "Input field"}
        className={`form-input w-full ${
          props.internaluser ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
        onChange={(e) => {
          onChange(e, id, type, preceding_0);
          updateValue(e);
        }}
        onBlur={(e) => {
          props.index.map((ele) => {
            activitydropdownparams.map((item) => {
              if (ele.label === item && ele.id === id) {
                setActivityParams(e.target.value);
              }
            });
          });
          if (
            props.validation_api_id !==
              "                                    " &&
            props.validation_api_id !== null &&
            checkfocus
          ) {
            setFocusControlId(props.id);
            onBlur(e, validation_api_id);
          }
        }}
        required={is_required}
        value={
          Object.keys(a_performance).length !== 0 && change
            ? controlvalue
            : value.value
        }
        disabled={props.internaluser}
      ></textarea>
      {validateobj?.map((item) => {
        return (
          item.id === id && (
            <div className="text-xs text-rose-600 pt-1 pl-1">
              Blank space is not allowed in {label || type + " field"}.
            </div>
          )
        );
      })}
    </div>
  );
};
NewTextareaComponent.defaultProps = {
  label: "Input field",
  min: 1,
  max: 10,
  required: false,
  placeholder: "",
  tooltip: "",
};

export const ListboxComponent = (props) => {
  const {
    index,
    id,
    type,
    onChange,
    label,
    tooltip,
    is_required,
    selected,
    onBlur,
    validation_api_id,
  } = props;
  const [listvalues, setListValues] = useState([]);
  const [value, setValue] = useState({});

  const {
    performanceid,
    setPerformanceId,
    submitperform,
    setSubmitPerform,
    setActivityParams,
    checkfocus,
    setFocusControlId,
  } = useContext(StateContext);

  const { activitydropdownparams } = useSelector((state) => state.performance);

  const [controlvalue, setControlValue] = useState();
  const [a_performance, setA_Performance] = useState([]);
  const [change, setChange] = useState(true);
  useEffect(() => {
    if (props.list_values !== "") {
      setListValues(JSON.parse(props.list_values));
    }
  }, []);

  useEffect(() => {
    if (performanceid !== undefined && performanceid.length !== 0) {
      getActivityPerformance(performanceid);
    }
  }, [performanceid]);
  useEffect(() => {
    if (a_performance.length !== 0) {
      a_performance.map((ele) => {
        if (ele.custom_field_id === props.id) {
          setControlValue(ele.value);
        }
      });
    }
  }, [a_performance]);

  useEffect(() => {
    if (submitperform) {
      setValue({ value: "" });
      setControlValue("");
      setTimeout(() => {
        setSubmitPerform(false);
      }, 2000);
    }
  }, [submitperform]);
  const getActivityPerformance = (id) => {
    setChange(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/activityperformance/${id}`)
      .then((res) => {
        setA_Performance(res.data.data[0].todo_custom_controls);
        setPerformanceId("");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateValue = (e) => {
    const { value } = e.target;
    setChange(false);
    setValue({ value: value });
  };
  return (
    <div className={wrapperClass + "pt-8 " + selected}>
      <label htmlFor={index} className="text-sm font-medium mb-1">
        {label || "Listbox"}
        {is_required === true ? (
          <span className="text-rose-500 ml-1">*</span>
        ) : null}
      </label>
      <div className="top-7 float-right pl-10 mb-1 rtl-grid">
        {tooltip !== "" && (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>
      <br />
      <select
        name={label || "Listbox"}
        className={`form-input w-full ${
          props.internaluser ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
        id={id}
        required={is_required}
        value={
          Object.keys(a_performance).length !== 0 && change
            ? controlvalue
            : value.value
        }
        disabled={props.internaluser}
        onBlur={(e) => {
          props.index.map((ele) => {
            activitydropdownparams.map((item) => {
              if (ele.label === item && ele.id === id) {
                setActivityParams(e.target.value);
              }
            });
          });
          if (
            props.validation_api_id !==
              "                                    " &&
            props.validation_api_id !== null &&
            checkfocus
          ) {
            setFocusControlId(props.id);
            onBlur(e, validation_api_id);
          }
        }}
        onChange={(e) => {
          onChange(e, id, type);
          updateValue(e);
        }}
      >
        {" "}
        <option value="">Select listbox value</option>;
        {listvalues.length !== 0
          ? listvalues.map((ele) => {
              return <option value={ele}>{ele}</option>;
            })
          : null}
      </select>
    </div>
  );
};
ListboxComponent.defaultProps = {
  label: "list",
  options: [{ id: 1, period: "Option 1" }],
  tooltip: "",
};

export const NewDropdownComponent = (props) => {
  const {
    index,
    id,
    type,
    label,
    onChange,
    tooltip,
    is_required,
    selected,
    onBlur,
    validation_api_id,
  } = props;
  const [apiresponse, setApiResponse] = useState([]);
  const [value, setValue] = useState({});

  const {
    performanceid,
    setPerformanceId,
    submitperform,
    setSubmitPerform,
    activityparams,
    setActivityParams,
    checkfocus,
    setFocusControlId,
  } = useContext(StateContext);

  const { activitydropdownparams } = useSelector((state) => state.performance);
  const { email, token } = useSelector((state) => state.auth);

  const [controlvalue, setControlValue] = useState();
  const [a_performance, setA_Performance] = useState([]);
  const [change, setChange] = useState(true);

  useEffect(() => {
    if (props.activity_id) {
      let activity_custom = props.id;
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/activityperformance/${props.activity_id}}/${email}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          let result = res.data.data;
          if (result.length !== 0) {
            result.todo_custom_controls.map((ele) => {
              if (ele.custom_field_id === activity_custom) {
                setValue({ value: ele.value });
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [props.activity_id]);

  useEffect(() => {
    if (
      props.api_name !== "" &&
      activityparams !== "" &&
      props.api_parameter !== ""
    ) {
      axios
        .get(`${props.api_name}/${activityparams}`)
        .then((res) => {
          setApiResponse(res.data);
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else if (props.api_name !== "" && props.api_parameter === "") {
      axios
        .get(`${props.api_name}`)
        .then((result) => {
          if (result.data[0]?.name?.common) {
            setApiResponse(result.data);
          } else {
            let arr = [];
            result.data.forEach((item) => {
              arr.push({ name: { common: item } });
            });
            setApiResponse(arr);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setApiResponse([]);
    }
  }, [activityparams]);
  useEffect(() => {
    if (performanceid !== undefined && performanceid.length !== 0) {
      getActivityPerformance(performanceid);
    }
  }, [performanceid]);
  useEffect(() => {
    if (a_performance.length !== 0) {
      a_performance.map((ele) => {
        if (ele.custom_field_id === props.id) {
          setControlValue(ele.value);
        }
      });
    }
  }, [a_performance]);

  useEffect(() => {
    if (submitperform) {
      setValue({ value: "" });
      setControlValue("");
      setTimeout(() => {
        setSubmitPerform(false);
      }, 2000);
    }
  }, [submitperform]);
  const getActivityPerformance = (id) => {
    setChange(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/activityperformance/${id}`)
      .then((res) => {
        setA_Performance(res.data.data[0].todo_custom_controls);
        setPerformanceId("");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const updateValue = (e) => {
    const { value } = e.target;
    setChange(false);
    setValue({ value: value });
  };
  return (
    <div className={wrapperClass + "pt-8 " + selected}>
      <label htmlFor={index} className="text-sm font-medium mb-1">
        {label || "Dropdown"}
        {is_required === true ? (
          <span className="text-rose-500 ml-1">*</span>
        ) : null}
      </label>
      <div className="top-7 float-right pl-10 mb-1 rtl-grid">
        {tooltip !== "" && (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>
      <br />
      <select
        name={label || "Dropdown"}
        className={`form-input w-full ${
          props.internaluser ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
        id={id}
        required={is_required}
        value={
          Object.keys(a_performance).length !== 0 && change
            ? controlvalue
            : value.value
        }
        onBlur={(e) => {
          props.index.map((ele) => {
            activitydropdownparams.map((item) => {
              if ((ele.label === item || item === "self") && ele.id === id) {
                setActivityParams(e.target.value);
              }
            });
          });
          if (
            props.validation_api_id !==
              "                                    " &&
            props.validation_api_id !== null &&
            checkfocus
          ) {
            setFocusControlId(props.id);
            onBlur(e, validation_api_id);
          }
        }}
        onChange={(e) => {
          onChange(e, id, type);
          updateValue(e);
        }}
        disabled={props.internaluser}
      >
        {" "}
        <option value="">Select Dropdown</option>;
        {apiresponse.length !== 0
          ? apiresponse.map((ele) => {
              return <option value={ele.name.common}>{ele.name.common}</option>;
            })
          : null}
      </select>
    </div>
  );
};
NewDropdownComponent.defaultProps = {
  label: "Dropdown",
  options: [{ id: 1, period: "Option 1" }],
  tooltip: "",
};

export const NewLinkComponent = (props) => {
  const { label, selected, open_in, id, tooltip, onBlur, validation_api_id } =
    props;
  const { setActivityParams, checkfocus, setFocusControlId } =
    useContext(StateContext);
  const { activitydropdownparams } = useSelector((state) => state.performance);
  return (
    <div className={wrapperClass + "pt-8 " + selected}>
      <div className="top-7 float-right pl-10 mb-1 rtl-grid">
        {tooltip !== "" && (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>
      <br />
      <div class="w-full">
        <button
          name={label || "Link"}
          className={`btn btn-blue bg-blue-500 text-white ${
            props.internaluser ? "cursor-not-allowed" : ""
          }`}
          onClick={(e) => {
            var res = props.url.match(
              /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
            );
            if (res !== null) {
              if (res[0].includes("http")) {
                open_in === "pop up"
                  ? window.open(props.url, "hello", "width=200,height=200")
                  : window.open(props.url, "_" + open_in);
              } else {
                open_in === "pop up"
                  ? window.open(
                      "https://" + props.url,
                      "hello",
                      "width=200,height=200"
                    )
                  : window.open("https://" + props.url, "_" + open_in);
              }
            }
            props.index.map((ele) => {
              if (ele.label === activitydropdownparams && ele.id === id) {
                setActivityParams(e.target.value);
              }
            });
            if (
              props.validation_api_id !==
                "                                    " &&
              props.validation_api_id !== null &&
              checkfocus
            ) {
              setFocusControlId(props.id);
              onBlur(e, validation_api_id);
            }
          }}
          disabled={props.internaluser}
        >
          {label || "Link"}
        </button>
      </div>
    </div>
  );
};
NewLinkComponent.defaultProps = { label: "Link", url: "/" };
export const NewTimeComponent = (props) => {
  const {
    index,
    label,
    id,
    type,
    min,
    max,
    is_required,
    placeholder,
    tooltip,
    onRemove,
    onSelect,
    selected,
    onChange,
    onBlur,
    validation_api_id,
  } = props;
  var check = 0;
  const {
    performanceid,
    setPerformanceId,
    submitperform,
    setSubmitPerform,
    setActivityParams,
    setFocusControlId,
    checkfocus,
  } = useContext(StateContext);
  const { activitydropdownparams } = useSelector((state) => state.performance);
  const [value, setValue] = useState({ value: "" });
  const [controlvalue, setControlValue] = useState();
  const [a_performance, setA_Performance] = useState([]);
  const [change, setChange] = useState(true);
  var required = is_required;
  useEffect(() => {
    if (performanceid !== undefined && performanceid.length !== 0) {
      getActivityPerformance(performanceid);
    }
  }, [performanceid]);
  useEffect(() => {
    if (a_performance !== 0) {
      a_performance.map((ele) => {
        if (ele.custom_field_id === props.id) {
          setControlValue(ele.value);
        }
      });
    }
  }, [a_performance]);

  useEffect(() => {
    if (submitperform) {
      setValue({ value: "" });
      setControlValue("");
      setTimeout(() => {
        setSubmitPerform(false);
      }, 2000);
    }
  }, [submitperform]);

  const getActivityPerformance = (id) => {
    setChange(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/activityperformance/${id}`)
      .then((res) => {
        setA_Performance(res.data.data[0].todo_custom_controls);
        setPerformanceId("");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const updateValue = (e) => {
    const value = e[0];
    setChange(false);
    setValue({ value: value });
  };
  return (
    <div className={wrapperClass + "pt-8 " + selected}>
      <label htmlFor={index} className="text-sm font-medium mb-1">
        {label || type}
        {required && <span className="text-rose-500 ml-1">*</span>}
      </label>
      <div className="top-7 float-right pl-10 mb-1 rtl-grid">
        {tooltip !== "" && (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>
      <br />
      <input
        {...{ type, min, id, max, required, placeholder }}
        name={label || type}
        key={index}
        className={`form-input w-full ${
          props.internaluser ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
        onChange={(e) => {
          onChange(e, id, type, min, max);
          updateValue(e);
        }}
        onBlur={(e) => {
          props.index.map((ele) => {
            activitydropdownparams.map((item) => {
              if (ele.label === item && ele.id === id) {
                setActivityParams(e.target.value);
              }
            });
          });
          if (
            props.validation_api_id !==
              "                                    " &&
            props.validation_api_id !== null &&
            checkfocus
          ) {
            setFocusControlId(props.id);
            onBlur(e, validation_api_id);
          }
        }}
        value={
          Object.keys(a_performance).length !== 0 && change
            ? controlvalue
            : value.value
        }
        disabled={props.internaluser}
      />
    </div>
  );
};

export const NewDateTimeComponent = (props) => {
  const {
    index,
    label,
    type,
    min,
    max,
    id,
    prior_date,
    future_date,
    is_required,
    placeholder,
    tooltip,
    onRemove,
    onSelect,
    selected,
    onChange,
    onBlur,
    validation_api_id,
  } = props;
  var check = 0;
  const {
    performanceid,
    setPerformanceId,
    submitperform,
    setSubmitPerform,
    setActivityParams,
    setFocusControlId,
    checkfocus,
  } = useContext(StateContext);
  const { activitydropdownparams } = useSelector((state) => state.performance);
  const [value, setValue] = useState({ value: "" });
  const [a_performance, setA_Performance] = useState([]);
  const [controlvalue, setControlValue] = useState();
  const [change, setChange] = useState(true);
  var required = is_required;
  useEffect(() => {
    if (performanceid !== undefined && performanceid.length !== 0) {
      getActivityPerformance(performanceid);
    }
  }, [performanceid]);
  useEffect(() => {
    if (a_performance !== 0) {
      a_performance.map((ele) => {
        if (ele.custom_field_id === props.id) {
          setControlValue(ele.value);
        }
      });
    }
  }, [a_performance]);
  useEffect(() => {
    if (submitperform) {
      setValue({ value: "" });
      setControlValue("");
      setTimeout(() => {
        setSubmitPerform(false);
      }, 2000);
    }
  }, [submitperform]);
  const getActivityPerformance = (id) => {
    setChange(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/activityperformance/${id}`)
      .then((res) => {
        setA_Performance(res.data.data[0].todo_custom_controls);
        setPerformanceId("");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateValue = (e) => {
    const value = e[0];
    setChange(false);
    setValue({ value: value });
  };
  return (
    <div className={wrapperClass + "pt-8 " + selected}>
      <label htmlFor={index} className="text-sm font-medium mb-1">
        {label || type}
        {required && <span className="text-rose-500 ml-1">*</span>}
      </label>
      <div className="top-7 float-right pl-10 mb-1 rtl-grid">
        {tooltip !== "" && (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>
      <Flatpickr
        data-enable-time
        options={{
          enableTime: true,
          altInput: true,
          altFormat: "j M, Y H:i",
          dateFormat: "Y-m-d H:i",
          time_24hr: true,
          minDate:
            prior_date === false
              ? moment().startOf("hour").format("YYYY-MM-DD HH:mm")
              : "",
          maxDate:
            future_date === false ? moment().format("YYYY-MM-DD HH:mm") : "",
        }}
        id={id}
        placeholder="Select Date/time"
        name={label || type}
        value={
          Object.keys(a_performance).length !== 0 && change
            ? moment(controlvalue).format("YYYY-MM-DD HH:mm")
            : value.value
        }
        onBlur={(e) => {
          props.index.map((ele) => {
            activitydropdownparams.map((item) => {
              if (ele.label === item && ele.id === id) {
                setActivityParams(e.target.value);
              }
            });
          });
          if (
            props.validation_api_id !==
              "                                    " &&
            props.validation_api_id !== null &&
            checkfocus
          ) {
            setFocusControlId(props.id);
            onBlur(e, validation_api_id);
          }
        }}
        onChange={(e) => {
          onChange(e, id, type, min, max);
          updateValue(e);
        }}
        disabled={props.internaluser}
        className={`form-input w-full ${
          props.internaluser ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
      />
    </div>
  );
};

export const DisableNewDateTimeComponent = (props) => {
  const {
    index,
    label,
    type,
    min,
    max,
    id,
    prior_date,
    future_date,
    is_required,
    placeholder,
    tooltip,
    onRemove,
    onSelect,
    selected,
    onChange,
    onBlur,
    validation_api_id,
  } = props;
  var check = 0;
  const {
    performanceid,
    setPerformanceId,
    submitperform,
    setSubmitPerform,
    setActivityParams,
    setFocusControlId,
    checkfocus,
  } = useContext(StateContext);
  const { activitydropdownparams } = useSelector((state) => state.performance);
  const [value, setValue] = useState({ value: "" });
  const [a_performance, setA_Performance] = useState([]);
  const [controlvalue, setControlValue] = useState();
  const [change, setChange] = useState(true);
  var required = is_required;
  useEffect(() => {
    if (performanceid !== undefined && performanceid.length !== 0) {
      getActivityPerformance(performanceid);
    }
  }, [performanceid]);
  useEffect(() => {
    if (a_performance !== 0) {
      a_performance.map((ele) => {
        if (ele.custom_field_id === props.id) {
          setControlValue(ele.value);
        }
      });
    }
  }, [a_performance]);
  useEffect(() => {
    if (submitperform) {
      setValue({ value: "" });
      setControlValue("");
      setTimeout(() => {
        setSubmitPerform(false);
      }, 2000);
    }
  }, [submitperform]);
  const getActivityPerformance = (id) => {
    setChange(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/activityperformance/${id}`)
      .then((res) => {
        setA_Performance(res.data.data[0].todo_custom_controls);
        setPerformanceId("");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateValue = (e) => {
    const value = e[0];
    setChange(false);
    setValue({ value: value });
  };
  return (
    <div className={wrapperClass + "pt-8 " + selected}>
      <label htmlFor={index} className="text-sm font-medium mb-1">
        {label || type}
        {required && <span className="text-rose-500 ml-1">*</span>}
      </label>
      <div className="top-7 float-right pl-10 mb-1 rtl-grid">
        {tooltip !== "" && (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>
      <Flatpickr
        data-enable-time
        options={{
          enableTime: true,
          altInput: true,
          altFormat: "j M, Y H:i",
          dateFormat: "Y-m-d H:i",
          time_24hr: true,
          minDate:
            prior_date === false
              ? moment().startOf("hour").format("YYYY-MM-DD HH:mm")
              : "",
          maxDate:
            future_date === false ? moment().format("YYYY-MM-DD HH:mm") : "",
        }}
        id={id}
        placeholder="Select Date/time"
        name={label || type}
        value={
          Object.keys(a_performance).length !== 0 && change
            ? moment(controlvalue).format("YYYY-MM-DD HH:mm")
            : value.value
        }
        onBlur={(e) => {
          props.index.map((ele) => {
            activitydropdownparams.map((item) => {
              if (ele.label === item && ele.id === id) {
                setActivityParams(e.target.value);
              }
            });
          });
          if (
            props.validation_api_id !==
              "                                    " &&
            props.validation_api_id !== null &&
            checkfocus
          ) {
            setFocusControlId(props.id);
            onBlur(e, validation_api_id);
          }
        }}
        onChange={(e) => {
          onChange(e, id, type, min, max);
          updateValue(e);
        }}
        disabled={props.internaluser}
        className={`form-input w-full ${
          props.internaluser ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
      />
    </div>
  );
};
